import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useSection } from '../../hooks/useSection';

interface AnalyticsTrackerProps {
  children?: React.ReactNode;
}

/**
 * Component that automatically tracks page views and section views
 */
export const AnalyticsTracker: React.FC<AnalyticsTrackerProps> = ({ children }) => {
  const location = useLocation();
  const section = useSection();

  // Initialize analytics with section context
  const analytics = useAnalytics({
    sectionId: section?.id,
    sectionName: section?.names?.fr,
    sectionType: section?.type_rubrique
  });

  // Track page view on route change
  useEffect(() => {
    analytics.trackPageView();
  }, [location.pathname, analytics]);

  // Track section view when section changes
  useEffect(() => {
    if (section?.id && section?.type_rubrique) {
      // Default to list view for most sections
      const viewType = section.type_rubrique === 'map' ? 'map' : 'list';
      analytics.trackSectionView(viewType);
    }
  }, [section?.id, section?.type_rubrique, analytics]);

  return children || null;
};

export default AnalyticsTracker;
